// extracted by mini-css-extract-plugin
export default {"container":"CharacterColors_container__nJg-Z","colors":"CharacterColors_colors__ub0kd","color":"CharacterColors_color__DRPSF"};